type IconProps = {
  color?: string;
}

function NewDownloadIcon({ color }: IconProps) {
  return (
    <svg width="16" height="16" viewBox="0 0 16 17" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M4.90648 8.37981L7.37966 11.0877L7.37966 1.41016C7.37966 1.13401 7.61159 0.910156 7.89769 0.910156C8.18379 0.910156 8.41572 1.13401 8.41572 1.41016L8.41572 11.1456L11.104 8.37981C11.2997 8.17834 11.6275 8.16812 11.8362 8.35697C12.045 8.54582 12.0556 8.86224 11.8599 9.06371L8.27563 12.7521C8.06673 12.9672 7.71134 12.962 7.50924 12.741L4.12959 9.04141C3.9403 8.83434 3.96077 8.51838 4.17531 8.33568C4.38984 8.15299 4.7172 8.17274 4.90648 8.37981ZM16 9.41016C16 9.13401 15.7761 8.91016 15.5 8.91016C15.2239 8.91016 15 9.13401 15 9.41016V15.8203C15 15.8699 14.9598 15.9102 14.9102 15.9102L1.08983 15.9102C1.04022 15.9102 1 15.8699 1 15.8203L1 9.41016C1 9.13401 0.776142 8.91016 0.5 8.91016C0.223858 8.91016 0 9.13401 0 9.41016V16.7533C0 16.8399 0.07023 16.9102 0.156863 16.9102L15.8431 16.9102C15.9298 16.9102 16 16.8399 16 16.7533V9.41016Z" fill={color} />
    </svg>
  );
}

export default NewDownloadIcon;
